import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

const retailerData = {
    retailerGln: '',
    name: ''
};

class CreateRetailerModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = retailerData;

        this.cancel = this.cancel.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.isValid = this.isValid.bind(this);
        this.submit = this.submit.bind(this);
    }

    cancel() {
        this.setState(retailerData);
        this.props.onCancel();
    }

    setProperty(propertyName, propertyValue) {
        const property = {[propertyName]: propertyValue};
        this.setState(property);
    }

    submit() {
        //validate
        this.props.onSubmit(this.state);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState(retailerData);
        }
    }

    isValid() {
        return this.state.retailerGln !== '' && this.state.name !== '';
    }

    render() {

        const disabled = !this.isValid();

        return (
            <Modal isOpen={this.props.visible} centered={true} className={this.props.className}>
                <ModalHeader>Neuer Händler</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="crModalRetailerGln">Händler-GLN</label>
                                    <input type="text" className="form-control" id="crModalRetailerGln"
                                           onChange={(event) => this.setProperty('retailerGln', event.target.value)}
                                           placeholder="GLN..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="crModalName">Händlername</label>
                                    <input type="text" className="form-control" id="crModalName"
                                           onChange={(event) => this.setProperty('name', event.target.value)}
                                           placeholder="Name..." required={true}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={disabled} color="primary" onClick={this.submit}>Händler anlegen</Button>{' '}
                    <Button color="secondary" onClick={this.cancel}>Abbrechen</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateRetailerModal;



// WEBPACK FOOTER //
// ./src/admin/retailer/CreateRetailerModal.js